import React from 'react';
import { IPRIVATE_TIME_ICON_PROPS } from './props';
import { getTheme } from '@fluentui/react';
import * as ReactDOMServer from 'react-dom/server';

export const ShareTimeIcon: React.FunctionComponent<IPRIVATE_TIME_ICON_PROPS> = (props) => {
  const theme = getTheme();
  const { style } = props;
  const iconHeight = style?.height ?? style?.fontSize;
  const primaryColor = style?.color ?? theme.palette.neutralPrimary;
  const indicatorColor = props.indicatorColor ?? primaryColor;
  
  return (
    <i style={style}>
      <svg style={{ width: '100%', height: iconHeight }} role='img' viewBox="364.034 302.593 119.749 95.211" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        {!!props.title && <title>{props.title}</title>}
        <g fill={primaryColor} >
          <path d="M 414.444 336.442
                    A 38.454 38.454, 0, 0, 1, 465.458 326.586
                    L 471.726 319.266
                    L 480.849 327.106
                    L 474.56 334.365
                    A 38.454 38.454, 0, 1, 1, 414.444 382.2585
                    L 421.075 382.259
                    A 33.363 33.363, 0, 1, 0, 421.075 336.442
                    Z" />
          <path d="M 448.836 365.68
                    A 7.236 7.236, 0, 1, 1, 452.137 361.804
                    L 468.418 375.667
                    A 28.272 28.272, 0, 0, 1, 465.118 379.543
                    Z" />
          <polyline points="442.563,320.996 442.563,310.363 437.372,310.363 437.372,307.684 453.288,307.684 453.288,310.363 448.097,310.363
                            448.097,320.996 453.187,321.708 453.187,315.454 458.378,315.454 458.378,302.593 432.281,302.593 432.281,315.454
                            437.472,315.454 437.472,321.708 442.563,320.996 "/>
        </g>
        <g fill={indicatorColor}>
          <path d="M 457.648 359.81
                    A 12.327 12.327, 0, 0, 0, 445.33 347.024
                    L 445.33 331.078
                    A 28.272 28.272, 0, 0, 1, 471.006 371.185
                    Z" />
        </g>
        <g fill={indicatorColor}>
          <polyline points="410.894,344.078 421.075,344.078 421.075,374.622 410.894,374.622 410.894,344.078 "/>
          <polyline points="380.35,349.169 390.531,349.169 390.531,374.622 380.35,374.622 380.35,349.169 "/>
          <polyline points="365.078,361.896 375.259,361.896 375.259,374.622 365.078,374.622 365.078,361.896 "/>
          <polyline points="395.622,354.26 405.803,354.26 405.803,374.622 395.622,374.622 395.622,354.26 "/>
        </g>
      </svg>
    </i>
  );
};

export const getShareTimeIconHtml = (props: IPRIVATE_TIME_ICON_PROPS) => {
  const html = ReactDOMServer.renderToString((<ShareTimeIcon {...props} />));
  return html;
};
